import React from 'react'
import WidgetWithSections from '../WidgetWithSections'
import WidgetContainer from '../../containers/WidgetContainer'
import SectionsMenu from '../../utils/SectionsMenu'
import DiscountsContainer from './DiscountsContainer'
import type { DailyDiscountsWidgetProps } from './Types'

export default class DailyDiscounts extends WidgetWithSections<DailyDiscountsWidgetProps> {
  render () {
    const {
      activeSection,
      boxes,
      sections
    } = this.state

    const {
      widget,
      widget: {
        imageSize,
        utmMedium,
        utmSource
      },
      googleAnalytics
    } = this.props

    const utmParams = {
      utmSource,
      utmMedium
    }

    const activeBoxes = boxes[activeSection]

    if (!activeBoxes.length) {
      return null
    }

    return (
      <WidgetContainer widget={widget} headlineContent={
        <SectionsMenu
          activeSection={activeSection}
          onSectionClick={this.handleSectionClick.bind(this)}
          sections={sections}
        />
      }>
        <DiscountsContainer
          boxes={activeBoxes}
          imageSize={imageSize}
          utmParams={utmParams}
          googleAnalytics={googleAnalytics}
        />
      </WidgetContainer>
    )
  }
}
